import * as React from 'react';
import {connect} from 'react-redux';

import get from 'lodash/get';
import set from 'lodash/set';
import unset from 'lodash/unset';

import {ActivityTypes} from 'nutshell-core/activity-types';
import {Assignables} from 'nutshell-core/assignables';
import {Routing} from 'nutshell-core/routing';
import * as Schema from 'nutshell-core/schema';
import type {UnserializedFilterObject, Assignable, ActivityType} from 'nutshell-core/types';

import {convertToModels} from 'shells/filter-capsule/convert-to-models';
import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';

import type {NutshellState} from '../../../../store';

// @ts-expect-error
import * as dashboardSelectors from '../../dashboard-selectors';

import styles from './feed-filters.module.css';

type OwnProps = {
    filter: string;
    onFilterUpdate: any;
    getFilterBarRef?: () => any;
};

type StateProps = {
    schema: Schema.Properties;
    assignables: Assignable[];
    activityTypes: ActivityType[];
};

type Props = OwnProps & StateProps;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        schema: dashboardSelectors.getDashboardSchema(state),
        assignables: Assignables.getAll(state),
        activityTypes: ActivityTypes.getAllLoggable(state),
    };
};

export class FeedFiltersComponent extends React.Component<Props> {
    render() {
        const formValues = Routing.deparam(this.props.filter);
        const typeEnums =
            Boolean(this.props.schema) &&
            this.props.schema.payload &&
            this.props.schema.payload.type === 'enum'
                ? convertToModels(
                      // @ts-expect-error
                      this.props.schema.payload.enum.filter((type) =>
                          type.id ? type.id !== 'marketingEmails' : undefined
                      )
                  )
                : undefined;

        const assignableModels = convertToModels(this.props.assignables);
        const activityTypes = convertToModels(this.props.activityTypes);

        return (
            <div ref={this.props.getFilterBarRef} className={styles.container}>
                <FilterCapsule
                    filter={get(formValues, 'payload')}
                    filterName='payload'
                    collection={typeEnums}
                    defaultValueTitle='Type'
                    hasSearch={false}
                    schemaField={this.props.schema.payload}
                    onSubmit={this.handleFilterSubmit}
                    // @ts-expect-error
                    onUpdate={this.handleFilterSubmit}
                    onRemove={this.handleFormFilterRemove}
                />
                <FilterCapsule
                    filter={get(formValues, 'activityType')}
                    filterName='activityType'
                    collection={activityTypes}
                    defaultValueTitle='Activity type'
                    schemaField={this.props.schema.activityType}
                    onSubmit={this.handleFilterSubmit}
                    // @ts-expect-error
                    onUpdate={this.handleFilterSubmit}
                    onRemove={this.handleFormFilterRemove}
                />
                <FilterCapsule
                    filter={get(formValues, 'creator')}
                    filterName='creator'
                    collection={assignableModels}
                    schemaField={this.props.schema.creator}
                    onSubmit={this.handleFilterSubmit}
                    // @ts-expect-error
                    onUpdate={this.handleFilterSubmit}
                    onRemove={this.handleFormFilterRemove}
                />
            </div>
        );
    }

    handleFilterSubmit = (data: UnserializedFilterObject<any>, key: string) => {
        const filterName = Object.keys(data)[0];
        // @ts-expect-error
        this.handleFormFilterChange(key, data[filterName]);
    };

    handleFormFilterChange = (key: string, newValue: string | any) => {
        const value = this.props.filter;

        const deparamedCurrentValue = Routing.deparam(value);
        set(deparamedCurrentValue, key, newValue);

        // When the activityType filter is set, we clear out any existing entryType filter
        // and replace with 'activities' so we only show the selected activity types. This
        // ensures the filter capsules match what is displayed in the timeline
        if (key === 'activityType' && !deparamedCurrentValue.payload) {
            deparamedCurrentValue.payload = {
                none: undefined,
                anyAll: 'any',
                data: [{data: 'activities'}],
            };
        }
        const paramedNewValue = Routing.param(deparamedCurrentValue);

        this.props.onFilterUpdate(paramedNewValue);
    };

    handleFormFilterRemove = (key: string) => {
        const deparamedCurrentValue = Routing.deparam(this.props.filter);
        unset(deparamedCurrentValue, key);
        const paramedNewValue = Routing.param(deparamedCurrentValue);

        this.props.onFilterUpdate(paramedNewValue);
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const FeedFilters = connector(FeedFiltersComponent);
